import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClaimOperationCP } from '../_models/claim-operation-cp.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestRoutes } from '../_config/rest-routes.config';
import { BehaviorSubject } from 'rxjs';
import { CountExpirate } from '../_models/count-expirate.model';
import { ClaimOperationInfo } from '../_models/claim-operation-info.model';
import { environment } from 'src/environments/environment';
import { HistoricStatesModule } from '../_models/historic-states.model';
import { HistoricStatesDTO } from '../_models/historicStatesDTO.model';
import { PagedResponseDTO } from '../_models/claim-operation-PagedResponseDTO.model copy';
import { ClaimOperationInfoDTO } from '../_models/claim-operation-ClaimOperationInfo.model';

@Injectable({
  providedIn: 'root',
})
export class ClaimOperationCPService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}


  ClaimOperations_Get(parameters: any): Observable<{ data: ClaimOperationCP[]; count: number }> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.CLAIMOPERATIONS_GET}${"?Page=1&PageSize=0"}`;
   //let urlCommerces: string = `${RestRoutes.CLAIM_LOCAL}`;
   /*console.log(urlCommerces)
      console.log(parameters)
         console.log(parameters.search)
         console.log(JSON.stringify(parameters, null, 2))*/

  return this.http
    .post<PagedResponseDTO<ClaimOperationInfoDTO>>(
      urlCommerces,
      parameters,
      this.httpOptions
    )
    .pipe(
      map(response => ({
        data: response.data.map(item => new ClaimOperationCP(item, response)),
        count: response.totalCount
      }))
    );
    }

  ClaimOperations_Get_Info(
    claimID: string,
    claimOperationId: string,
  ): Observable<ClaimOperationCP> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.CLAIMOPERATIONS_GETINFO}/${claimOperationId}/info?claimId=${claimID}`;
    return this.http.get<ClaimOperationCP>(urlCommerces, this.httpOptions);
  }

  GetClaimOperationHistoricState(
    claimid: any,
    claimoperationid: any,
  ): Observable<HistoricStatesDTO[]> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.CLAIMOPERATIONS_GETINFO}/${claimoperationid}/historicStates?claimId=${claimid}`;
    // console.log(urlCommerces)
    return this.http.get<HistoricStatesDTO[]>(urlCommerces, this.httpOptions);
  }

  GetClaimOperationByUser(claimoperationid: any): Observable<string> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.CLAIMOPERATIONS_GETBYUSER}/${claimoperationid}/LastRequiredElements`;
    // console.log(urlCommerces)
    return this.http.get<string>(urlCommerces, this.httpOptions);
  }
}
